import { spacing } from "@/theme/tokens";
import { Box, Stack } from "@mui/material";
import LocationCarousel from "./LocationCarousel";
import { Location } from "./types";
import { useLocationCarousel } from "./useLocationCarousel";
import { useTranslations } from "next-intl";
import NavigationControls from "@/components/common/NavigationControls";

interface USOfficeLocationsProps {
    locationsData: Location[];
    carousel: ReturnType<typeof useLocationCarousel>;
}

export default function USOfficeLocations({ locationsData, carousel }: USOfficeLocationsProps) {
    const tInfo = useTranslations('HomePage.locationsInfo');
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: spacing[48], md: spacing[64] } }}>
            <Stack gap={{
                xs: spacing[48],
                sm: spacing[48],
                md: spacing[64],
                position: 'relative'
            }}>
                <LocationCarousel
                    locations={locationsData}
                    carousel={carousel}
                />
            </Stack>
            <NavigationControls
                currentSlide={carousel.currentSlide}
                totalSlides={carousel.totalSlides}
                onPrev={carousel.prevSlide}
                onNext={carousel.nextSlide}
                goToSlide={carousel.goToSlide}
                nextLabel={tInfo('nextLocation')}
                previousLabel={tInfo('previousLocation')}
                arrowsTopPositionOffset={55} // 55% of the container height
            />
        </Box>
    );
}
